import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["xlink:href"];
import '../../icons/iconfont';
import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const symbolId = computed(() => {
      return `#cess-icon_${props.iconClass}`;
    });
    const svgClass = computed(() => {
      if (props.className) {
        return 'svg-icon ' + props.className;
      } else {
        return 'svg-icon';
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", _mergeProps({
        class: svgClass.value,
        "aria-hidden": "true"
      }, _ctx.$attrs), [_createElementVNode("use", {
        "xlink:href": symbolId.value
      }, null, 8, _hoisted_1)], 16);
    };
  }
});